/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react'
import Slider, { Settings } from 'react-slick'

import '../assets/css/style.css'
import coins from '../assets/img/icon/coins.svg'
import elderly from '../assets/img/icon/elderly.svg'
import school from '../assets/img/icon/school.svg'
import externalLink from '../assets/img/icon/external_link.svg'
import titleKyouiku from '../assets/img/title/title_kyouiku.svg'
import titleMarket from '../assets/img/title/title_market.svg'
import titleNisa from '../assets/img/title/title_nisa.svg'
import titleReport from '../assets/img/title/title_report.svg'
import titleRougo from '../assets/img/title/title_rougo.svg'
import titleRougoSimulation from '../assets/img/title/title_rougo_simulation.svg'
import titleShisan from '../assets/img/title/title_shisan.svg'
import titleShoraiSimulation from '../assets/img/title/title_shorai_simulation.svg'
import titleSurvey from '../assets/img/title/title_survey.svg'
import titleTorikuzushiSimulation from '../assets/img/title/title_torikuzushi_simulation.svg'
import titleToushin from '../assets/img/title/title_toushin.svg'
import titleTumitate from '../assets/img/title/title_tumitate.svg'
import titleTumitateSimulation from '../assets/img/title/title_tumitate_simulation.svg'
import sliderArrowLeft from '../assets/img/icon/slider_arrow_left.svg'
import sliderArrowRight from '../assets/img/icon/slider_arrow_right.svg'
import { Link } from 'react-router-dom'
import { Header } from '../components/header'
import { Footer } from '../components/footer'
import { useHeadTitle } from '../hook/useHeadTitle'
import { useDealerCodeUrl } from '../hook/useDealerCode'
import { useDescription } from '../hook/useDescription'

interface ArrowProps {
  className?: string
  style?: {}
  onClick?: VoidFunction
}

const NextArrow = (props: ArrowProps) => {
  const { className, onClick } = props
  const _classNames = 'c-carousel__arrow--next slick-arrow' + className
  return <img src={sliderArrowRight} alt="" className={_classNames} onClick={onClick} />
}

const PrevArrow = (props: ArrowProps) => {
  const { className, onClick } = props
  const _classNames = 'c-carousel__arrow--prev slick-arrow' + className
  return <img src={sliderArrowLeft} alt="" className={_classNames} onClick={onClick} />
}

export default function Top() {
  const sliderSettings: Settings = {
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    infinite: false,
  }

  useHeadTitle('今こそ資産運用を考えよう')
  useDescription(
    '資産運用について知っておきたい基本とコツ。野村アセットマネジメントが資産運用に取り組む皆さまをサポートします。'
  )

  useEffect(() => {
    document.querySelector('body')?.classList.add('p-home__body')

    return () => document.querySelector('body')?.classList.remove('p-home__body')
  })

  const maxSpWidth = 1171
  const [breakPoint, setIsMobile] = useState(window.innerWidth <= maxSpWidth)
  const handleResize = () => {
    setIsMobile(window.innerWidth <= maxSpWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const Introduction = () => {
    return (
      <div className="p-home__slider__item">
        <section>
          <h2 className="p-home__heading--1">資産運用をはじめよう</h2>
          <ul className="p-home__link-group">
            <li className="p-home__link-group__unit--3col">
              <Link to={useDealerCodeUrl('/shisan')} className="p-home__link--primary">
                <span className="p-home__link__inner">
                  <span className="p-home__link__title">
                    <img src={titleShisan} alt="資産運用" />
                  </span>
                  <span className="p-home__link__icon icon--primary">
                    <img src={coins} alt="" />
                  </span>
                  <br />
                  <span className="p-home__link__sub-text">超低金利がつづく今だから</span>
                </span>
              </Link>
            </li>
            <li className="p-home__link-group__unit--3col">
              <Link to={useDealerCodeUrl('/rougo')} className="p-home__link--primary">
                <span className="p-home__link__inner">
                  <span className="p-home__link__title">
                    <img src={titleRougo} alt="老後資金" />
                  </span>
                  <span className="p-home__link__icon">
                    <img src={elderly} alt="" />
                  </span>
                  <br />
                  <span className="p-home__link__sub-text">何から始めればいいの？</span>
                </span>
              </Link>
            </li>
            <li className="p-home__link-group__unit--3col">
              <Link to={useDealerCodeUrl('/kyouiku')} className="p-home__link--primary">
                <span className="p-home__link__inner">
                  <span className="p-home__link__title">
                    <img src={titleKyouiku} alt="教育資金" />
                  </span>
                  <span className="p-home__link__icon icon--primary">
                    <img src={school} alt="" />
                  </span>
                  <br />
                  <span className="p-home__link__sub-text">どのくらい準備する？</span>
                </span>
              </Link>
            </li>
          </ul>
        </section>
        <section>
          <h2 className="p-home__heading--2">知っておきたい投資のコトバ</h2>
          <ul className="p-home__link-group">
            <li className="p-home__link-group__unit--3col">
              <Link to={useDealerCodeUrl('/toushin')} className="p-home__link--primary">
                <span className="p-home__link__inner">
                  <span className="p-home__link__title">
                    <img src={titleToushin} alt="投資信託とは" />
                  </span>
                  <br />
                  <span className="p-home__link__sub-text">仕組みとコツ</span>
                </span>
              </Link>
            </li>
            <li className="p-home__link-group__unit--3col">
              <Link to={useDealerCodeUrl('/tsumitate')} className="p-home__link--primary">
                <span className="p-home__link__inner">
                  <span className="p-home__link__title">
                    <img src={titleTumitate} alt="つみたて投資とは" />
                  </span>
                  <br />
                  <span className="p-home__link__sub-text">コツコツ買って長く続けよう</span>
                </span>
              </Link>
            </li>
            <li className="p-home__link-group__unit--3col">
              <a
                href="https://www.nomura-am.co.jp/nisa/"
                target="_blank"
                className="p-home__link--primary"
                rel="noopener"
              >
                <span className="p-home__link__inner p-home__link__oneline">
                  <span className="p-home__link__title">
                    <img src={titleNisa} alt="はじめるならNISA" />
                  </span>
                  <span className="p-home__link__icon--blank">
                    <img src={externalLink} alt="" />
                  </span>
                </span>
              </a>
            </li>
          </ul>
        </section>
      </div>
    )
  }

  const Tool = () => {
    return (
      <div className="p-home__slider__item">
        <section>
          <h2 className="p-home__heading--1">資産運用に役立つ便利ツール</h2>
          <ul className="p-home__link-group">
            <li className="p-home__link-group__unit--2col">
              <Link to={useDealerCodeUrl('/calc')} className="p-home__link--secondary">
                <span className="p-home__link__inner">
                  <span className="p-home__link__title">
                    <img src={titleTumitateSimulation} alt="つみたてシミュレーション" />
                  </span>
                  <br />
                  <span className="p-home__link__sub-text sp-text-wrap">
                    金額や期間などを決めて
                    <br />
                    「つみたて」を計算
                  </span>
                </span>
              </Link>
            </li>
            <li className="p-home__link-group__unit--2col">
              <Link to={useDealerCodeUrl('/simulation')} className="p-home__link--secondary">
                <span className="p-home__link__inner">
                  <span className="p-home__link__title">
                    <img src={titleShoraiSimulation} alt="将来シミュレーション" />
                  </span>
                  <br />
                  <span className="p-home__link__sub-text sp-text-wrap">
                    あなたの資産の将来を
                    <br />
                    預金と比べてみましょう
                  </span>
                </span>
              </Link>
            </li>
          </ul>
          <ul className="p-home__link-group u-mt36px">
            <li className="p-home__link-group__unit--2col">
              <Link to={useDealerCodeUrl('/reversal')} className="p-home__link--secondary">
                <span className="p-home__link__inner">
                  <span className="p-home__link__title">
                    <img src={titleTorikuzushiSimulation} alt="取り崩しシミュレーション" />
                  </span>
                  <br />
                  <span className="p-home__link__sub-text sp-text-wrap">
                    取り崩し額によって
                    <br />
                    資産寿命はどう変わる？
                  </span>
                </span>
              </Link>
            </li>
            <li className="p-home__link-group__unit--2col">
              <Link to={useDealerCodeUrl('/rougoSimulation')} className="p-home__link--secondary">
                <span className="p-home__link__inner">
                  <span className="p-home__link__title">
                    <img src={titleRougoSimulation} alt="老後資金シミュレーション" />
                  </span>
                  <br />
                  <span className="p-home__link__sub-text sp-text-wrap">
                    セカンドライフに必要な資金を
                    <br />
                    イメージ
                  </span>
                </span>
              </Link>
            </li>
          </ul>
        </section>
        <section>
          <h2 className="p-home__heading--1">マーケットをチェック</h2>
          <ul className="p-home__link-group">
            <li className="p-home__link-group__unit--3col">
              <a
                href="https://www.nomura-am.co.jp/market/report/"
                target="_blank"
                rel="noopener"
                className="p-home__link--tertiary"
              >
                <span className="p-home__link__title">
                  <img src={titleReport} alt="投資環境レポート" />
                </span>
                <span className="p-home__link__icon--blank">
                  <img src={externalLink} alt="" />
                </span>
              </a>
            </li>
            <li className="p-home__link-group__unit--3col">
              <a
                href="https://www.nomura-am.co.jp/market/marketcomment/"
                target="_blank"
                rel="noopener"
                className="p-home__link--tertiary"
              >
                <span className="p-home__link__title">
                  <img src={titleMarket} alt="マーケットコメント" />
                </span>
                <span className="p-home__link__icon--blank">
                  <img src={externalLink} alt="" />
                </span>
              </a>
            </li>
            <li className="p-home__link-group__unit--3col">
              <a
                href="https://www.nomura-am.co.jp/amrc/opinion-survey/"
                target="_blank"
                rel="noopener"
                className="p-home__link--tertiary"
              >
                <span className="p-home__link__title">
                  <img src={titleSurvey} alt="意識調査" />
                </span>
                <span className="p-home__link__icon--blank">
                  <img src={externalLink} alt="" />
                </span>
              </a>
            </li>
          </ul>
        </section>
      </div>
    )
  }

  return (
    <React.Fragment>
      <Header />
      <main>
        <div className="p-home">
          {breakPoint ? (
            <React.Fragment>
              <Introduction />
              <Tool />
            </React.Fragment>
          ) : (
            <Slider className="p-home__slider js-home-slider" {...sliderSettings}>
              <Introduction />
              <Tool />
            </Slider>
          )}
        </div>
      </main>
      <Footer />
    </React.Fragment>
  )
}
